import './App.css'
import './Pages.css'
import { Route, Routes } from 'react-router-dom'
import Home from './home'
import './DateExtensions' // Must exist at a higher place, in order to set up the datetime prototypes
import OrganizationYearWeekPage from './OrganizationYearWeekPage'
import { SignalRProvider } from './SignalRContext'
import Consts from './Const'
import UgeDagPage from './UgeDagPage'
import Privacy from './privacy'
import FeedBack from './feedback'
import Reporting from './reporting'
import Dashboard from './dashboard'
import VSOSudoku from './VSOSudoku'
import RankyTank from './rankytank'
import TekstUr from './tekstur'
import HusHold from './hushold'
import TekstUrPrivacy from './teksturprivacy'
import TekstUrSupport from './tekstursupport'
import Support from './support'
import HusholdSupport from './husholdsupport'
import HusholdPrivacy from './privacyhushold'
import OrganizationYearWeekPageSwitcher from './OrganizationYearWeekPageSwitcher'
import Editor from './WooNotes/WooNotes'
import HusholdSerpAPI from './privacyserpapi'

function App() {
  // return <KeylanePage />

  // useEffect(() => {
  //     const connectSignalR = async () => {
  //         await setupSignalRConnection();
  //     };
  //     connectSignalR();
  // }, []);
  
  const routes = (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/woonotes" element={<Editor />} />
      <Route path="/rankytank" element={<RankyTank />} />
      <Route path="/hushold" element={<HusHold />} />
      <Route path="/tekstur" element={<TekstUr />} />
      <Route path="/tekstursupport" element={<TekstUrSupport />} />
      <Route path="/teksturprivacy" element={<TekstUrPrivacy />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/husholdprivacy" element={<HusholdPrivacy />} />
      <Route path="/husholdserpapi" element={<HusholdSerpAPI />} />
      <Route path="/husholdsupport" element={<HusholdSupport />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/reporting" element={<Reporting />} />
      <Route path="/feedback" element={<FeedBack />} />
      <Route path="/support" element={<Support />} />
      <Route path="/r/keylane" element={<OrganizationYearWeekPageSwitcher organizationId="8c0193a8-bb41-4623-8199-5c8a3ecd3088" />} />
      <Route path="/r/organizationyearweekpage" element={<OrganizationYearWeekPage activityType={0} />} />
      <Route path="/r/ugedag" element={<UgeDagPage />} />
      <Route path="/vsosudoku" element={<VSOSudoku />} />

      {/* This only exists to support the old pattern given to Rasmus Resen https://ranky.woohooo.dk/keylane */}
      <Route path="/keylane" element={<OrganizationYearWeekPageSwitcher organizationId="8c0193a8-bb41-4623-8199-5c8a3ecd3088" />} />
    </Routes>
  )

  if (!Consts.enableSignalR) return routes

  return <SignalRProvider>{routes}</SignalRProvider>
}

export default App
